function init() {
	const form = document.querySelector("[data-form='signup']");
	const fields = form.querySelector(".form__fields");
	const success = form.querySelector(".form__success");
	const error = form.querySelector(".form__fields-error");

	form.onsubmit = (e) => {
		e.preventDefault();

		error.removeAttribute("style");

		const formData = new FormData(form);
		const email = formData.get("email");
		const csrf = formData.get("CRAFT_CSRF_TOKEN");
		const body = { email, CRAFT_CSRF_TOKEN: csrf };

		const serialize = (obj) => {
			var str: string[] = [];
			for (var p in obj)
				if (obj.hasOwnProperty(p)) {
					str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
				}
			return str.join("&");
		};

		fetch("/mailchimp/send", {
			method: "post",
			body: serialize(body),
			headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
		})
			.then((r) => r.json())
			.then((r) => {
				if (r.success) {
					// alert(r.msg);
					fields.style.display = "none";
					success.style.display = "block";
				} else {
					// alert(r.msg);
					let errMsg = r.msg;
					if (errMsg == "Mailchimp error: Member Exists") {
						errMsg = "It looks like you're already signed up to our mailing list!";
					}
					error.innerHTML = errMsg;
					error.style.display = "block";
				}
			})
			.catch((err) => {
				console.error(err);
				error.innerHTML = "Something went wrong - if the problem persists please contact us";
				error.style.display = "block";
			});
	};
}

export default init;
